import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46416d1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "help-screen" }
const _hoisted_2 = { class: "modal-mask" }
const _hoisted_3 = { class: "modal-wrapper" }
const _hoisted_4 = { class: "button-bar" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createElementVNode("i", { class: "fal fa-angle-right" })
], -1))
const _hoisted_6 = { class: "modal-header" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "Help Section:", -1))
const _hoisted_8 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, null, -1))
const _hoisted_10 = {
  class: "ql-container ql-snow ql-disabled",
  style: {"width":"100%","border":"none"}
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = { class: "modal-footer row" }

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_Transition, { name: "modal" }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["modal-container", [{'is-closing' : _ctx.isClosing} ]])
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, [
                  _createElementVNode("button", {
                    class: "btn btn-outline sml",
                    onClick: _cache[0] || (_cache[0] = (...args) => (_ctx.close && _ctx.close(...args)))
                  }, [
                    _createTextVNode(" Close "),
                    _hoisted_5
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _renderSlot(_ctx.$slots, "header", {}, () => [
                  _hoisted_7
                ], true)
              ]),
              (_ctx.helpContent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _renderSlot(_ctx.$slots, "body", {}, () => [
                      _createElementVNode("h4", null, _toDisplayString(_ctx.helpContent.title), 1),
                      _hoisted_9,
                      _createElementVNode("div", _hoisted_10, [
                        _createElementVNode("div", {
                          class: "ql-editor ql-blank",
                          "data-gramm": "false",
                          contenteditable: "false",
                          style: {"padding":"0 0"},
                          innerHTML: _ctx.helpContent.content
                        }, null, 8, _hoisted_11)
                      ])
                    ], true)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_12, [
                _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
              ])
            ], 2)
          ])
        ])
      ]),
      _: 3
    })
  ]))
}